export default __webpack_public_path__ + "static/media/item5.aeddc2a8.png";